import type { ComponentProps } from 'react';
import styled from 'styled-components';

import { ButtonBase } from 'atoms/buttons/ButtonBase';

const StyledButton = styled(ButtonBase)`
  display: block;
  font-size: inherit;
  color: var(--c-blue-400);
`;

export const createResendEmailConfirmationButton = (
  buttonProps: ComponentProps<typeof ButtonBase>
) => {
  return function Link(...chunks: string[]) {
    return (
      <StyledButton type="button" {...buttonProps}>
        {chunks}
      </StyledButton>
    );
  };
};
